import { useAtomValue } from "jotai";
import { type CSSProperties, useRef } from "react";
import { widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { TOOLTIP_BUTTON_CLASS } from "../../constants/tooltipButtonClass";
import type { SetActiveSubMenu } from "../../types";
import styles from "./TextFontButton.module.css";

interface TextFontButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function TextFontButton({ setActiveSubMenu }: TextFontButtonProps) {
    const wrapperRef = useRef<HTMLDivElement>(null);

    const options = useAtomValue(widgetMenuOptionsByNameAtom("textFont"));
    const currentFont = (options[0]?.value as string) ?? "";

    const handleButtonClick = () => {
        const anchor = wrapperRef.current;

        if (!anchor) {
            return;
        }

        setActiveSubMenu((prev) =>
            prev?.name === "textFont" ? null : { name: "textFont", anchor },
        );
    };

    const displayedFontStyle = currentFont
        ? ({
              "--button-font-family": `'${currentFont}'`,
          } as CSSProperties)
        : undefined;

    return (
        <div ref={wrapperRef}>
            <button
                type="button"
                className={`${styles.button} ${TOOLTIP_BUTTON_CLASS}`}
                data-tooltip="Шрифт"
                onClick={handleButtonClick}
            >
                <span className={styles.value} style={displayedFontStyle}>
                    {currentFont}
                </span>
            </button>
        </div>
    );
}
